const mapObj = {
  monitor: [
    {
      position: [88.916994, 43.377223],
      off: [-30, -30],
      className: 'monitorclass',
      name: 'monitor',
    },
    {
      position: [88.983499, 43.434235],
      off: [-30, -30],
      className: 'monitorclass',
      name: 'monitor',
    },
    {
      position: [89.004028, 43.593772],
      off: [-30, -30],
      className: 'monitorclass',
      name: 'monitor',
    },
    {
      position: [88.789927, 43.501773],
      off: [-30, -30],
      className: 'monitorclass',
      name: 'monitor',
    },
  ],
  wifi: [
    {
      position: [88.916994, 43.377223],
      off: [-30, -30],
      className: 'wificlass',
      name: 'wifi',
    },
    {
      position: [88.929723, 43.48062],
      off: [-30, -30],
      className: 'wificlass',
      name: 'wifi',
    },
    {
      position: [88.982318, 43.544615],
      off: [-30, -30],
      className: 'wificlass',
      name: 'wifi',
    },
    {
      position: [88.78622, 43.50129],
      off: [-30, -30],
      className: 'wificlass',
      name: 'wifi',
    },
    {
      position: [88.918199, 43.577991],
      off: [-30, -30],
      className: 'wificlass',
      name: 'wifi',
    },
  ],

  parkingLot: [
    {
      position: [88.85094, 43.548047],
      off: [-30, -30],
      className: 'parkingLotclass',
      name: 'parkingLot',
    },
  ],
}
export default mapObj
